<template>
  <div class="select-picker">
    <van-popup v-model="visible" position="bottom" :style="{ height: height }">
      <div class="room-select-box">
        <van-search
          placeholder="房号/订单号/客人姓名"
          style="border-bottom:1px solid #f1f1f1;"
          class="search-box"
          v-model="keyword"
          @search="onSearch"
        />
        <div
          v-for="item in orderList"
          :key="item.OrderId"
          class="order-room-item"
        >
          <div class="order-title">
            订单号：<span>{{ item.OrderNo }}</span>
          </div>
          <van-radio-group v-model="checkRoomId">
            <van-radio
              v-for="room in item.AppointRoomInfos"
              :name="room.RoomInfoId"
              :key="room.GuestId"
              class="check-item"
              @click="onChange(room)"
            >
              <div class="room-no">
                {{ room.RoomNo ? room.RoomNo : "未排房" }}
                <span class="guest-room"> 客人姓名：{{ room.GuestName }}</span>
              </div>

              <span class="date">
                住 ：{{ room.CheckInDate }} 离： {{ room.CheckOutDate }}</span
              >
            </van-radio>
          </van-radio-group>
        </div>
      </div>
      <van-button type="primary" block @click="onSubmit">确定</van-button>
    </van-popup>
  </div>
</template>

<script>
import restaurantManageApi from "@/api/restaurantManage.js";

import {
  Notify,
  Popup,
  Picker,
  Cell,
  CellGroup,
  Icon,
  Search,
  Radio,
  RadioGroup,
  Button,
} from "vant";
export default {
  name: "SelectMultiplePicker",
  components: {
    [Button.name]: Button,
    [Notify.name]: Notify,
    [Popup.name]: Popup,
    [Picker.name]: Picker,
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell,
    [Icon.name]: Icon,
    [Search.name]: Search,
    [Radio.name]: Radio,
    [RadioGroup.name]: RadioGroup,
  },
  props: {
    height: {
      type: String,
      default: "100%",
    },

    change: { type: Function },
  },
  data() {
    return {
      visible: false,
      keyword: "",
      orderList: [],
      checkRoomId: "",
      allRoomData: [],
      currentRoom: {},
    };
  },
  created: function() {},
  mounted() {},

  methods: {
    show() {
      this.visible = true;
      this.allRoomData = [];
      this.getRoomNos();
    },
    onLoadCallBack(res) {
      return res.Data;
    },
    getRoomNos() {
      this.orderList = [];
      restaurantManageApi
        .getAppointRoomInfo({
          Keyword: this.Keyword,
          OrderStatus: 1,
        })
        .then(res => {
          if (res.Data.length) {
            this.orderList = res.Data.map(v => {
              if (v.AppointRoomInfos && v.AppointRoomInfos.length) {
                v.AppointRoomInfos = v.AppointRoomInfos.map(el => {
                  el.TargetOrderId = v.OrderId;
                  return el;
                });
                this.allRoomData = this.allRoomData.concat(v.AppointRoomInfos);
              }
              return v;
            });
          }
        });
    },
    onSearch(val) {
      this.Keyword = val;
      this.getRoomNos();
    },
    cancel() {
      this.visible = false;
      this.$emit("cancel");
    },
    onChange(item) {
      this.currentRoom = item;
    },
    onSubmit() {
      this.$emit("submit", this.currentRoom);
      this.visible = false;
    },
  },
};
</script>

<style lang="less" scoped>
.room-select-box {
  position: relative;
  height: calc(100% - 45px);
  overflow: auto;
  padding-top: 56px;
  .search-box {
    position: absolute;
    top: 0;
    width: 100%;
  }
}
.order-room-item {
  padding: 0 10px 15px 10px;
  border-bottom: 1px dashed #eaeaea;
  font-size: 14px;
  .order-title {
    padding: 5px 10px;
    background: #f7f8fa;
    margin-bottom: 5px;
    margin: 0 -10px 5px -10px;
    color: #999;
  }
}
</style>
